document.addEventListener('DOMContentLoaded', function() {
  // Function to randomly select and reorder slides
  function initializeRandomSlides() {
    const slidesContainer = document.querySelector('.slides-container');
    if (!slidesContainer) return;

    // Get all slides
    const allSlides = Array.from(slidesContainer.querySelectorAll('.slide'));
    
    // If we have 6 or fewer slides, just randomize their order
    if (allSlides.length <= 6) {
      // Shuffle array using Fisher-Yates algorithm
      for (let i = allSlides.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [allSlides[i], allSlides[j]] = [allSlides[j], allSlides[i]];
      }
      // Reorder slides in DOM
      allSlides.forEach(slide => slidesContainer.appendChild(slide));
    } else {
      // If we have more than 6 slides, randomly select 6
      const selectedSlides = [];
      const availableIndices = Array.from({length: allSlides.length}, (_, i) => i);
      
      // Select 6 random slides
      for (let i = 0; i < 6; i++) {
        const randomIndex = Math.floor(Math.random() * availableIndices.length);
        const slideIndex = availableIndices.splice(randomIndex, 1)[0];
        selectedSlides.push(allSlides[slideIndex]);
      }
      
      // Remove all slides first
      allSlides.forEach(slide => slide.remove());
      
      // Add selected slides back in random order
      selectedSlides.sort(() => Math.random() - 0.5);
      selectedSlides.forEach(slide => slidesContainer.appendChild(slide));
    }
  }

  // Initialize random slides before getting the slides for the slider
  initializeRandomSlides();

  // Get all slides after randomization
  const allSlides = document.querySelectorAll(".slide");
  
  // Initialize variables
  let slideIndex = 0;
  const slides = Array.from(allSlides);
  const dots = document.querySelectorAll(".dot");
  const fixedContent = document.querySelector(".fixed-content");
  const navIcons = document.querySelector(".slider-header-bar");
  const pagination = document.querySelector(".pagination");
  const arrows = document.querySelectorAll(".prev, .next");
  const burgerMenu = document.querySelector(".burger-menu");
  const menuSidebar = document.querySelector(".menu-sidebar");
  const closeButton = menuSidebar?.querySelector('.close-button');
  const hotspot = document.querySelector('.hotspot');
  const tooltip = hotspot?.querySelector('.tooltip');
  const tooltipText = tooltip?.querySelector('.tooltip-text');
  const tooltipArrow = tooltip?.querySelector('.tooltip-arrow');
  let isAnimating = false;
  let isHotspotAnimating = false;
  let touchStartX = 0;
  let touchEndX = 0;

  // Function to update hotspot content
  function updateHotspotContent(slide) {
    const tooltip = document.querySelector('.tooltip');
    const tooltipContent = document.querySelector('.tooltip-content');
    const tooltipText = document.querySelector('.tooltip-text');
    
    if (!tooltip || !tooltipContent || !tooltipText) return;
    
    const title = slide.dataset.hotspotTitle || '';
    const url = slide.dataset.hotspotUrl || '#';
    
    tooltipText.textContent = title;
    tooltipContent.href = url;

    // Check if URL is valid
    if (url === '#' || !url) {
      tooltipContent.style.pointerEvents = 'none';
    } else {
      tooltipContent.style.pointerEvents = 'auto';
    }
  }

  function updateTheme(index) {
    const theme = slides[index].dataset.theme + '-theme';
    fixedContent.className = `fixed-content ${theme}`;
    navIcons.className = `slider-header-bar ${theme}`;
    pagination.className = `pagination ${theme}`;
    arrows.forEach(arrow => {
      arrow.className = arrow.classList[0] + ' ' + theme;
    });
  }

  // Slider functions
  window.moveSlide = function(n) {
    if (isAnimating) return;
    isAnimating = true;

    // Add fade animation to hotspot
    if (hotspot && !isHotspotAnimating) {
      isHotspotAnimating = true;
      hotspot.classList.add('fade');
    }

    const currentSlide = slides[slideIndex];
    slideIndex = (slideIndex + n + slides.length) % slides.length;
    const nextSlide = slides[slideIndex];

    nextSlide.style.transform = n > 0 ? 'translateX(100%)' : 'translateX(-100%)';
    nextSlide.style.opacity = '0';
    nextSlide.style.visibility = 'visible';
    
    updateTheme(slideIndex);
    
    // Delay before updating hotspot content
    setTimeout(() => {
      updateHotspotContent(nextSlide);
      if (hotspot) {
        hotspot.classList.remove('fade');
        isHotspotAnimating = false;
      }
    }, 500);

    requestAnimationFrame(() => {
      currentSlide.style.transform = n > 0 ? 'translateX(-100%)' : 'translateX(100%)';
      currentSlide.style.opacity = '0';
      
      nextSlide.style.transform = 'translateX(0)';
      nextSlide.style.opacity = '1';
      
      dots.forEach((dot, i) => dot.classList.toggle("active", i === slideIndex));
    });

    setTimeout(() => {
      currentSlide.classList.remove('active');
      currentSlide.style.visibility = 'hidden';
      nextSlide.classList.add('active');
      isAnimating = false;
    }, 1000);
  };

  window.currentSlide = function(n) {
    if (isAnimating) return;
    const diff = n - 1 - slideIndex;
    if (diff !== 0) {
      moveSlide(diff);
    }
  };

  // Initialize event handlers
  if (hotspot) {
    // Remove click handler for hotspot since the whole tooltip is now a link
    
    // Close tooltip when clicking outside hotspot
    document.addEventListener('click', function(e) {
      if (!hotspot.contains(e.target)) {
        hotspot.classList.remove('active');
      }
    });
  }

  // Custom search modal logic
  const desktopSearchBtn = document.querySelector('.custom-desktop-search-icon');
  const mobileSearchBtn = document.querySelector('.custom-mobile-search-icon');
  const desktopSearchModal = document.querySelector('.header__search');
  const mobileSearchModal = document.querySelector('.mobile-search-wrapper .header__search');
  const mobileSearchWrapper = document.querySelector('.mobile-search-wrapper');
  const mobileCloseBtn = document.querySelector('.mobile-search-close');

  // Desktop search icon click
  if (desktopSearchBtn && desktopSearchModal) {
    desktopSearchBtn.addEventListener('click', function(e) {
      e.preventDefault();
      desktopSearchModal.classList.add('active');
      const details = desktopSearchModal.querySelector('details');
      if (details) details.setAttribute('open', 'open');
      const input = desktopSearchModal.querySelector('input[type="search"]');
      if (input) input.focus();
    });
  }

  // Mobile search icon click
  if (mobileSearchBtn && mobileSearchModal && mobileSearchWrapper) {
    mobileSearchBtn.addEventListener('click', function(e) {
      e.preventDefault();
      mobileSearchWrapper.classList.add('active');
      mobileSearchModal.classList.add('active');
      const details = mobileSearchModal.querySelector('details');
      if (details) details.setAttribute('open', 'open');
      const input = mobileSearchModal.querySelector('input[type="search"]');
      if (input) input.focus();
    });
  }

  // Close mobile search
  if (mobileCloseBtn && mobileSearchModal && mobileSearchWrapper) {
    mobileCloseBtn.addEventListener('click', function() {
      mobileSearchModal.classList.remove('active');
      mobileSearchWrapper.classList.remove('active');
      const details = mobileSearchModal.querySelector('details');
      if (details) details.removeAttribute('open');
    });
  }

  // On page load, ensure close button is hidden
  if (mobileCloseBtn) mobileCloseBtn.style.display = 'none';

  // Close desktop search when clicking outside
  document.addEventListener('mousedown', function(e) {
    if (desktopSearchModal && desktopSearchModal.classList.contains('active')) {
      if (!desktopSearchModal.contains(e.target) && !desktopSearchBtn.contains(e.target)) {
        desktopSearchModal.classList.remove('active');
        const details = desktopSearchModal.querySelector('details');
        if (details) details.removeAttribute('open');
      }
    }
  });

  // Sidebar menu
  if (burgerMenu && menuSidebar) {
    burgerMenu.addEventListener('click', function(e) {
      e.stopPropagation();
      menuSidebar.classList.add('active');
      document.body.classList.add('menu-active');
    });

    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.stopPropagation();
        menuSidebar.classList.remove('active');
        document.body.classList.remove('menu-active');
      });
    }

    document.addEventListener('click', function(e) {
      if (!menuSidebar.contains(e.target) && !burgerMenu.contains(e.target)) {
        menuSidebar.classList.remove('active');
        document.body.classList.remove('menu-active');
      }
    });
  }

  // Country selector handling
  const countryButton = document.querySelector('.country-selector-button');
  const dropdown = document.querySelector('.country-selector-dropdown');

  if (countryButton && dropdown) {
    countryButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const isHidden = dropdown.hasAttribute('hidden');
      
      if (isHidden) {
        dropdown.removeAttribute('hidden');
        countryButton.setAttribute('aria-expanded', 'true');
      } else {
        dropdown.setAttribute('hidden', '');
        countryButton.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('click', function(e) {
      if (!countryButton.contains(e.target) && !dropdown.contains(e.target)) {
        dropdown.setAttribute('hidden', '');
        countryButton.setAttribute('aria-expanded', 'false');
      }
    });

    const countryLinks = dropdown.querySelectorAll('a');
    countryLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const form = this.closest('form');
        if (!form) return;

        const countryInput = form.querySelector('input[name="country_code"]');
        if (countryInput) {
          countryInput.value = this.dataset.value;
        }

        form.submit();
      });
    });
  }

  // Swipe handling
  document.addEventListener('touchstart', e => {
    touchStartX = e.changedTouches[0].screenX;
  }, false);

  document.addEventListener('touchend', e => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  }, false);

  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        moveSlide(1);
      } else {
        moveSlide(-1);
      }
    }
  }

  // Initialization
  slides[0].classList.add('active');
  dots[0].classList.add('active');
  updateTheme(0);
  updateHotspotContent(slides[0]);

  // Auto slide transition
  setInterval(() => {
    if (!isAnimating) {
      moveSlide(1);
    }
  }, 8000);

  // --- Fallback: Polling for search modal open/close state ---
  const headerBar = document.querySelector('.slider-header-bar');
  const searchModal = document.querySelector('.header__search');
  if (headerBar && searchModal) {
    const details = searchModal.querySelector('details');
    const modal = searchModal.querySelector('.search-modal');
    if (details && modal) {
      setInterval(() => {
        if (details.open) {
          headerBar.style.top = '0';
          headerBar.style.padding = '0';
          modal.style.top = '-20px';
        } else {
          headerBar.style.top = '40px';
          headerBar.style.padding = '0 60px';
          modal.style.top = '';
        }
      }, 100);
    }
  }
});


document.addEventListener('DOMContentLoaded', function() {
  // Language selector button handler
  const languageButton = document.querySelector('.language-selector-button');
  if (languageButton) {
    languageButton.addEventListener('click', function(e) {
      e.preventDefault();
      const dropdown = this.nextElementSibling;
      dropdown.hidden = !dropdown.hidden;
    });
  }

  // Language selection handler
  const languageLinks = document.querySelectorAll('#language-form .language-selector-dropdown a');
  languageLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const form = document.getElementById('language-form');
      form.querySelector('input[name="locale_code"]').value = this.dataset.value;
      form.submit();
    });
  });

  // Close language dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('#language-form')) {
      const dropdown = document.querySelector('.language-selector-dropdown');
      if (dropdown) {
        dropdown.hidden = true;
      }
    }
  });
});

// Function to update cart count
function updateCartCount() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update cart count bubbles in hero slider
      const cartCountBubbles = document.querySelectorAll('.slider-header-bar .cart-count-bubble span[aria-hidden="true"]');
      cartCountBubbles.forEach(bubble => {
        bubble.textContent = cart.item_count;
      });

      // Show/hide bubble based on count
      const cartBubbles = document.querySelectorAll('.slider-header-bar .cart-count-bubble');
      cartBubbles.forEach(bubble => {
        if (cart.item_count > 0) {
          bubble.style.display = 'flex';
        } else {
          bubble.style.display = 'none';
        }
      });
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

// Function to update wishlist count
function updateWishlistCount() {
  let count = 0;
  if (window.RdnlWishlist && typeof window.RdnlWishlist.getAll === 'function') {
    const items = window.RdnlWishlist.getAll();
    count = items.length;
  } else {
    // Fallback to localStorage if RdnlWishlist is not available
    const storedItems = localStorage.getItem('rendl_wishlist');
    if (storedItems) {
      try {
        const parsedItems = JSON.parse(storedItems);
        if (Array.isArray(parsedItems)) {
          count = parsedItems.length;
        } else if (parsedItems && parsedItems.categories && Array.isArray(parsedItems.categories)) {
          count = parsedItems.categories.reduce((acc, category) => acc + (category.items ? category.items.length : 0), 0);
        }
      } catch (e) {
        console.error('Error parsing wishlist from localStorage:', e);
      }
    }
  }

  // Update wishlist count bubbles in hero slider
  const wishlistCountBubbles = document.querySelectorAll('.slider-header-bar .wishlist-count-bubble span[aria-hidden="true"]');
  wishlistCountBubbles.forEach(bubble => {
    bubble.textContent = count;
  });

  // Show/hide bubble based on count
  const wishlistBubbles = document.querySelectorAll('.slider-header-bar .wishlist-count-bubble');
  wishlistBubbles.forEach(bubble => {
    if (count > 0) {
      bubble.style.display = 'flex';
    } else {
      bubble.style.display = 'none';
    }
  });
}

// Initialize counts on page load
document.addEventListener('DOMContentLoaded', function() {
  // Initial updates
  updateCartCount();
  updateWishlistCount();

  // Listen for cart updates
  document.addEventListener('cart:updated', function() {
    updateCartCount();
  });

  // Listen for wishlist updates
  document.addEventListener('wishlist:updated', function() {
    updateWishlistCount();
  });

  // Also update wishlist count if RdnlWishlist becomes available after a delay
  if (!window.RdnlWishlist) {
    setTimeout(updateWishlistCount, 500);
    setTimeout(updateWishlistCount, 1500);
  }
});


